import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Routing } from '../../app.routes';
import { AuthStateService } from '../../shared/services/state/auth-state.service';

/**
 * Empêche un client reprenant un projet créé par un apporteur d'accéder aux
 * étapes amont (project, infos, tarifs) par navigation directe (URL, retour navigateur...) —
 * Sans effet pour l'apporteur ou un client venu du parcours grand public.
 */
export const lockedClientStepGuard: CanActivateFn = () => {
  const authStateService = inject(AuthStateService);
  const router = inject(Router);

  const isLocked = authStateService.selectIsClientOfProducerProject()();
  if (isLocked) {
    router.navigate([Routing.SOUSCRIPTION]).then();
    return false;
  }

  return true;
};
